<!-- Four numbers separated by rules rather than boxed in cards — the negative
     margin pulls each divider into the column gap. -->
<div class="grid grid-cols-2 lg:grid-cols-4 gap-x-10 border-b border-border">
  @if (isLoading()) {
    @for (i of [1, 2, 3, 4]; track i) {
      <div class="py-[26px] flex flex-col gap-3">
        <div class="h-3 w-24 rounded bg-muted animate-pulse"></div>
        <div class="h-8 w-16 rounded bg-muted animate-pulse"></div>
        <div class="h-3 w-28 rounded bg-muted animate-pulse"></div>
      </div>
    }
  } @else {
    @for (metric of metrics(); track metric.label; let first = $first) {
      <div
        class="py-[26px]"
        [class]="first ? '' : 'lg:pl-10 lg:-ml-10 lg:border-l lg:border-border'"
      >
        <div class="font-mono text-2xs uppercase tracking-[0.06em] text-muted-foreground whitespace-nowrap">
          {{ metric.label }}
        </div>
        <div class="flex items-baseline gap-2 mt-3">
          <span
            class="text-3xl font-bold leading-none tracking-tight tabular-nums"
            [class]="metric.alert ? 'text-destructive' : 'text-foreground'"
          >
            {{ metric.value }}
          </span>
          @if (metric.unit) {
            <span class="text-dense text-muted-foreground">{{ metric.unit }}</span>
          }
        </div>
        <div class="mt-2.5 font-mono text-2xs text-muted-foreground">{{ metric.note }}</div>
      </div>
    }
  }
</div>
